<template>
  <div class="home-wrapper">

    <!-- Floating Icons -->
    <div class="floating-icons">

      <!-- Add as many icons as you like -->
      <i class="bi bi-laptop-fill float-item fi1"></i>
      <i class="bi bi-globe2 float-item fi2"></i>
      <i class="bi bi-cpu-fill float-item fi3"></i>
      <i class="bi bi-wifi float-item fi4"></i>
      <i class="bi bi-brush-fill float-item fi5"></i>
      <i class="bi bi-shield-lock-fill float-item fi6"></i>
      <i class="bi bi-keyboard-fill float-item fi7"></i>
      <i class="bi bi-mouse-fill float-item fi8"></i>
      <i class="bi bi-code-slash float-item fi9"></i>
      <i class="bi bi-cloud-fill float-item fi10"></i>

    </div>

    <!-- Main Content -->
    <div class="content">
      <h1 class="title">
        Welcome to <span>EduLearn Academy</span>
      </h1>

      <p class="subtitle">
        ICT Tutorials, Courses, Programming, and Technology Lessons — Simplified for everyone.
      </p>

      <div class="btn-group">
        <router-link to="/tutorials" class="btn-main">Explore Tutorials</router-link>
        <router-link to="/courses" class="btn-secondary">View Courses</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>

/* Background */
.home-wrapper {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #f2fcff, #fde2f3, #e4ecff);
  position: relative;
  overflow: hidden;
  padding-left: 260px;
}

@media (max-width: 991px) {
  .home-wrapper {
    padding-left: 0;
  }
}

/* Floating Icons */
.floating-icons {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* Gradient colored icons */
.float-item {
  position: absolute;
  font-size: 3.5rem;
  opacity: 0.9;
  background: linear-gradient(45deg, #ff6ec4, #7873f5, #4adede);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 0px 10px rgba(124, 77, 255, 0.4));
  animation: floatAnim 14s infinite ease-in-out;
}

/* Icon Positions */
.fi1 { top: 10%; left: 15%; animation-duration: 16s; }
.fi2 { top: 25%; left: 70%; animation-duration: 19s; }
.fi3 { top: 55%; left: 12%; animation-duration: 14s; }
.fi4 { top: 72%; left: 55%; animation-duration: 18s; }
.fi5 { top: 35%; left: 42%; animation-duration: 22s; }
.fi6 { top: 12%; left: 82%; animation-duration: 20s; }
.fi7 { top: 60%; left: 75%; animation-duration: 25s; }
.fi8 { top: 75%; left: 30%; animation-duration: 23s; }
.fi9 { top: 45%; left: 5%;  animation-duration: 26s; }
.fi10 { top: 5%; left: 50%; animation-duration: 28s; }

/* Floating Animation */
@keyframes floatAnim {
  0% { transform: translateY(0) translateX(0); opacity: 0.6; }
  50% { transform: translateY(-50px) translateX(30px); opacity: 1; }
  100% { transform: translateY(0) translateX(0); opacity: 0.6; }
}

/* Main Content */
.content {
  position: relative;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
}

.title {
  font-size: 3.8rem;
  font-weight: 800;
  color: #283593;
  max-width: 700px;
}

.title span {
  background: linear-gradient(45deg, #ff6ec4, #7873f5, #4adede);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 1.3rem;
  color: #424242;
  max-width: 600px;
  margin: 20px 0;
}

/* Buttons */
.btn-group {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.btn-main {
  background: linear-gradient(45deg, #ff6ec4, #7873f5);
  color: white;
  padding: 12px 30px;
  border-radius: 12px;
  text-decoration: none;
  font-size: 1.15rem;
  font-weight: 600;
  transition: 0.3s;
  box-shadow: 0 6px 20px rgba(120, 115, 245, 0.4);
}

.btn-main:hover {
  transform: translateY(-3px);
}

.btn-secondary {
  background: white;
  color: #283593;
  padding: 12px 30px;
  border-radius: 12px;
  text-decoration: none;
  font-size: 1.15rem;
  border: 2px solid #283593;
  transition: 0.3s;
}

.btn-secondary:hover {
  background: #283593;
  color: white;
}

/* Mobile Responsive Adjustments */
@media (max-width: 768px) {
  .title {
    font-size: 2.4rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }

  .float-item {
    font-size: 2.5rem;
  }

  .btn-group {
    flex-direction: column;
    width: 80%;
  }

  .content {
    text-align: center;
    align-items: center;
  }
}
</style>
